import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { ImageFormats } from "../../../../components/finalForms/libs/data/imageFormatTypes";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../data/gridColumnType";

const initState = {
  customerName: "",
  companyName: "",
  companyWebUrl: "",
  countryId: null,
  address: "",
  city: "",
  state: "",
  primaryEmail: "",
  customerLogo: "",
  primaryContactPhone: "",
  isActive: true,
};

export const customerFormData = {
  name: "Customer form",
  initialState: initState,
  section: [
    {
      sectionId: "customer",
      title: "customer form Section",
      row: {},
      style: {
        sectionStyle: "col-lg-9 col-md-6",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "customerName",
          label: "Customer Name",
          Field_Name: "customer name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "customerName",
          fieldSetting: {
            placeholder: "Please Enter Customer Name",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "companyName",
          label: "Company Name",
          Field_Name: "company name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "companyName",
          fieldSetting: {
            placeholder: "Please Enter Company Name",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "companyWebUrl",
          label: "Company Web URL",
          Field_Name: "company web url",
          fieldType: FormFieldTypes.INPUT,
          dataField: "companyWebUrl",
          fieldSetting: {
            placeholder: "Please Enter Company Web URL",
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "address",
          label: "Address",
          Field_Name: "address",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "address",
          fieldSetting: {
            placeholder: "Please Enter Address",
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "city",
          label: "City",
          Field_Name: "city",
          fieldType: FormFieldTypes.INPUT,
          dataField: "city",
          fieldSetting: {
            placeholder: "Please Enter City",
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "state",
          label: "State",
          Field_Name: "state",
          fieldType: FormFieldTypes.INPUT,
          dataField: "state",
          fieldSetting: {
            placeholder: "Please Enter State",
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "countryId",
          label: "Country",
          Field_Name: "country",
          fieldType: FormFieldTypes.SELECT,
          dataField: "countryId",
          fieldSetting: {
            placeholder: "Please Select Country",
            allowSpace: true,
            options: [],
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "primaryEmail",
          label: "Email Address",
          Field_Name: "email address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "primaryEmail",
          fieldSetting: {
            placeholder: "Please Enter Email Address",
            allowSpace: true,
          },
          validation: [
            {
              type: validationTypes.EMAIL,
            },
          ],
          style: {
            containerCss: "col-lg-8 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "primaryContactPhone",
          label: "Contact Number",
          Field_Name: "contact number",
          fieldType: FormFieldTypes.PHONE,
          dataField: "primaryContactPhone",
          fieldSetting: {
            placeholder: "Please Enter Contact Number",
            allowSpace: true,
            // maskFormat: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },

        {
          id: "isActive",
          label: "Active",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss:
              "col-4 col-md-6 my-2  double-label-sec checkbox-style",
          },
        },
      ],
    },
    {
      title: "customerLogo Section2",
      row: {},
      style: {
        sectionStyle: "col-lg-3 col-md-6 mb-2",
      },
      fields: [
        {
          id: "customerLogo",
          Field_Name: "customer profile",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "customerLogo",
          fieldSetting: {
            placeholder: "Upload Customer Logo",
            allowMultipleImage: false,
            imageUpload: true,
            isDownloadable: false,
            minImageSizeInMB: 0,
            maxImageSizeInMB: 2,
            acceptedImageFormats: [
              ImageFormats.JPEG,
              ImageFormats.JPG,
              ImageFormats.PNG,
            ],
          },
          validation: [{ type: validationTypes.IMAGE }],
          style: {
            containerCss:
              "col-lg-12 col-md-6 mb-2 file-upload-container validation-left-0",
          },
        },
      ],
    },
  ],
};

// formFields: [
//   {
//     container: true,
//     style: {
//       containerCss: "col-lg-12 col-md-12",
//     },
//     row: [
//       {
//         fields: [
//     {
//       id: "customerLogo",
//       Field_Name: "Customer Profile",
//       fieldType: FormFieldTypes.FILE,
//       dataField: "customerLogo",
//       fieldSetting: {
//         allowSpace: true,
//         imageUpload: true,
//       },
//       validation: [{ type: validationTypes.REQUIRE }],
//       style: {
//         containerCss: "col-lg-12 col-md-6 mb-2 validation-left-0",
//       },
//     },
//   ],
// },
//     ],
//   },
// ],

export const GridConfig = {
  columns: [
    {
      name: "Customer Name",
      fieldName: "customerName",
    },
    {
      name: "Company Name",
      fieldName: "companyName",
    },
    {
      name: "Email Address",
      fieldName: "primaryEmail",
    },
    {
      name: "Phone number",
      fieldName: "primaryContactPhone",
      allowShort: false,
    },
    {
      name: "Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
    },
  ],
};